export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyCGU700F3qZHboSlTTf4fhLcc6H_32AKDs',
    authDomain: 'loianetraining.firebaseapp.com',
    databaseURL: 'https://loianetraining.firebaseio.com',
    projectId: 'loianetraining',
    storageBucket: 'loianetraining.appspot.com',
    messagingSenderId: '97355788027'
  }
};
